// Category enum mirrored from CommandModal so the page can group watchlist
// items the same way the dialog does.
export enum CategoryEnum {
  CRYPTO = "crypto",
  STOCKS = "stocks",
  COMMODITIES = "commodities",
  FX = "fx",
  INDICES = "indices",
  PRE_IPO = "pre_ipo",
}
